<template>
  <div class="container-fluid">
    <page-header
      :page="page"
      :actions="headerActionConfig"
      right-side-class="col-xl-4 align-items-end d-flex pb-2 justify-content-end"
    />

    <validation-observer ref="discussion" tag="form">
      <filter-manager
        v-model="searchFilterModel"
        icon-button="fas fa-search"
        :filters="searchFilterHeader"
        :display-advanced="false"
        @search="onSearch"
      />
    </validation-observer>

    <custom-separator
      text="Resultado de Vigencia de Consultas"
      class="my-4 custom-separator-line"
    />

    <custom-result-not-found
      v-if="!results.length"
      text="No hay información disponible."
    />

    <template v-else>
      <validation-observer ref="validities">
        <div v-for="(item, idx) of results" :key="`row-${idx}`" class="mb-3">
          <search-result
            :item="item"
            :academic-year-id="searchFilterModel.academicYear.id"
            @on-open-close="openCloseResultHandler($event, idx)"
          />
          <div
            v-if="rowErrors(item).length"
            class="bg-secondary-19 rounded-bottom p-3 color-secondary-20"
          >
            <div
              v-for="(error, errorIdx) of rowErrors(item)"
              :key="`error-${errorIdx}`"
              class="mb-1"
            >
              <em class="fas fa-times-circle mr-2" />
              {{ error.errorMessage }}
            </div>
          </div>
        </div>
      </validation-observer>
      <pagination
        v-if="pagination.totalItemCount > pagination.pageSize"
        :data="pagination"
        show-text
        @pagination-go-page="goToPage"
      />
    </template>
    <!--  -->
  </div>
</template>
<script>
import Pagination from "pagination";
import PageHeader from "PageHeader";
import alert from "@/mixin/alert.mixin";
import CustomSeparator from "custom-separator";
import FilterManager from "FilterManager";
import CustomResultNotFound from "custom-result-not-found";
import SearchResult from "@/components/pei/ubication-tech-assistance/validityRequest/components/SearchResult.vue";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers(
  "ubication-tech-assistance-mngmt"
);
import {
  getTabRequestValidity,
  saveValidity
} from "@/services/api/tapRequest.api.js";
import moment from "moment";

export default {
  name: "ValidityRequest",
  components: {
    PageHeader,
    CustomSeparator,
    CustomResultNotFound,
    FilterManager,
    SearchResult,
    Pagination
  },
  mixins: [alert],
  data: () => ({
    page: {
      icon: "fas fa-user-edit",
      title: "Vigencia de Consultas",
      routes: [
        "Inicio",
        "PEI",
        "Manejo de Solicitud de Asistencia Técnica de Ubicación del Estudiante"
      ]
    },
    searchFilterModel: {
      academicYear: null,
      sie: null
    },
    pagination: {
      currentPage: 1,
      totalItemCount: 0,
      pageCount: 1,
      count: 0,
      pageSize: 10
    },
    results: [],
    errors: []
  }),
  computed: {
    ...mapState(["filters", "collections"]),
    rowErrors() {
      return ({ requestId }) => {
        const errors = this.errors.filter(e => e.requestId == requestId);
        return errors;
      };
    },
    headerActionConfig() {
      return [
        {
          text: "Regresar",
          icon: "fas fa-arrow-circle-left",
          variant: "outline-success",
          click: () => this.$router.go(-1)
        },
        {
          text: "Guardar",
          icon: "fas fa-save",
          variant: "success",
          visible: this.results.length != 0,
          click: () => this.saveValidityHandler()
        }
      ];
    },
    searchFilterHeader() {
      return [
        {
          name: "academicYear",
          component: "CustomDropDown",
          options: this.collections.academicYears,
          value: this.searchFilterModel.academicYear,
          fieldName: "description",
          fieldKey: "id",
          class: "col-12 col-md-5 ml-0 mr-0",
          classContainer: "w-100",
          clearable: false,
          validations: "required",
          error: "El año académico es requerido."
        },
        {
          name: "sie",
          component: "CustomInput",
          placeholder: "Escriba Número de SIE",
          value: this.searchFilterModel.sie,
          class: "col-12 col-md-7",
          icon: "fa fa-search orange-icon",
          leftIcon: true,
          maskType: "sieorRegIdNumber",
          validations: "required",
          error: "El número de SIE es requerido."
        }
      ];
    }
  },
  async created() {
    this.searchFilterModel.academicYear = this.filters.academicYear;
  },
  methods: {
    async saveValidityHandler() {
      const isValid = await this.$refs.validities.validate();
      if (!isValid) {
        this.ShowToast(
          "Alerta",
          "Favor de completar la información solicitada.",
          "error"
        );
        return;
      }
      this.errors = [];

      this.results.forEach(it => {
        var assignmentStartDate = moment(it.assignmentStartDate).format(
          "YYYY-MM-DD"
        );

        var assignmentEndDate = moment(it.assignmentEndDate).format(
          "YYYY-MM-DD"
        );

        var approvalDate = moment(it.statusLog.createdDate).format(
          "YYYY-MM-DD"
        );

        if (it.statusLog != null) {
          if (moment(assignmentStartDate).isBefore(moment(approvalDate))) {
            this.errors.push({
              requestId: it.requestId,
              errorMessage:
                "La fecha de inicio no puede ser menor que la aprobación de la consulta."
            });
          }
        } else {
          this.errors.push({
            requestId: it.requestId,
            errorMessage: "La consulta no ha sido aprobada."
          });
        }

        if (it.hasBilledSubmittedVisits) {
          this.errors.push({
            requestId: it.requestId,
            errorMessage:
              "No es posible modificar la vigencia ya que cuenta con servicios facturados."
          });
        }
        if (it.tapRequestVisits != null) {
          var copyVisits = [...it.tapRequestVisits];
          var firstVisit = copyVisits.slice(0, 1);

          firstVisit = moment(
            firstVisit[0].visitDate.toString().split("T")[0]
          ).format("YYYY-MM-DD");

          var lastVisit = copyVisits.pop();
          lastVisit = moment(
            lastVisit.visitDate.toString().split("T")[0]
          ).format("YYYY-MM-DD");

          if (
            moment(assignmentStartDate).isAfter(moment(firstVisit)) ||
            moment(assignmentEndDate).isBefore(moment(lastVisit))
          ) {
            this.errors.push({
              requestId: it.requestId,
              errorMessage:
                "Los servicios registrados quedan fuera de vigencia seleccionada."
            });
          }

          if (
            moment(assignmentStartDate).isBefore(
              moment(it.academicYear.fromDate)
            ) ||
            moment(assignmentEndDate).isAfter(moment(it.academicYear.toDate))
          ) {
            this.errors.push({
              requestId: it.requestId,
              errorMessage:
                "La vigencia seleccionada no pertenece al año fiscal."
            });
          }
        }
      });

      if (this.errors.length > 0) {
        return;
      }

      const params = this.results.map(i => ({
        requestId: i.requestId,
        assignmentStartDate: i.assignmentStartDate,
        assignmentEndDate: i.assignmentEndDate
      }));

      await saveValidity(params)
        .then(() => {
          this.ShowToast(
            "Proceso Exitoso",
            "Los datos fueron guardados exitosamente.",
            "success"
          );
        })
        .catch(err => {
          this.ShowToast("Error", err.response.data.message, "error");
        });
    },
    async goToPage(page) {
      this.pagination.currentPage = page;
      await this.onSearch();
    },
    async onSearch() {
      const isValid = await this.$refs.discussion.validate();
      if (!isValid) return;

      const params = {
        academicYearId: this.searchFilterModel.academicYear?.id,
        studentSieId: this.searchFilterModel.sie,
        pageIndex: this.pagination.currentPage,
        pageSize: this.pagination.pageSize
      };
      const { data: response } = await getTabRequestValidity(params);
      this.results = [...response.data];
      this.pagination = {
        ...this.pagination,
        currentPage: response.currentPage,
        count: response.count,
        pageCount: response.pageCount,
        totalItemCount: response.totalItemCount
      };
    },
    openCloseResultHandler(value, idx) {
      this.results = this.results.map((r, i) => ({
        ...r,
        isOpen: i === idx ? !value : false
      }));
    }
  }
};
</script>
